import React from 'react';
import clsx from 'clsx';
import { EmptyStateSVG } from '@components/Landing/FeaturedStatus/EmptyStateSVG';

export const EmptyState = ({
  title,
  subTitle,
  button,
}: {
  title: string;
  subTitle?: string;
  button?: React.ReactNode;
}) => {
  return (
    <div className="flex h-[350px] w-full flex-col items-center justify-center rounded-md bg-base50 px-4 py-16 text-center">
      <div className="hidden sm:block">
        <EmptyStateSVG />
      </div>
      <span
        className={clsx(
          'mt-4 font-title text-title-m font-medium text-base900',
          !subTitle && 'mb-6',
        )}
      >
        {title}
      </span>
      {subTitle && <span className="mb-6 mt-2 font-base text-base-m text-base600">{subTitle}</span>}
      {button}
    </div>
  );
};
